import React, { useEffect, useState, useCallback, useRef } from 'react'
import { connect } from 'react-redux'
import '../index.scss'
import ReusableButton from '../../reusableComponents/button/customButton'
import DropDownMenu from '../../reusableComponents/dropDownMenu/DropDownMenu'
import SideDrawerMenu from '../../reusableComponents/sideDrawerMenu/sideDrawerMenu'
// import HuntPlannerRightToolBar from '../huntPlanner-right-toolbar'
// import FilterComponent from '../moreFilterMenu'
// import FilterComponent from '../moreFilterMenu/index'
import { fetchHuntPlannerLayers } from '../../../../action/huntplanner-state-Filter-actions'
// import { multiTileHuntLayers, removeZoomEVent } from '../../huntplanner-layer-render/renderlayerFunction'
// import { removeLayers, multiTileHuntLayers, removeZoomEVent, multiTileHuntLayersXYZ } from '../../huntplanner-layer-render/renderlayerFunction'
import { huntPlannerFilterOptions } from '../../../../action/huntplanner-filterOptions-action'
import { huntPlannerActiveOtions } from '../../../../action/huntplanner-selected-options'
import { formattedText } from '../../../../lib/util'
import { huntplannerMorefilters, closeMorefilterMenu, expandMorefilterMenu } from "../../../../action/huntplanner-morefilters-actions";
import { fetchGetFilterCount, fetchGetStateGetExtent, fetchGetFilterValues } from '../../../../action/huntPlanner-api-actions'
import { huntPlannerRightMenuBarexpand, huntPlannerRightMenuBarHide } from '../../../../action/huntplanner-menu-bar'
import { stopMapLoading, startMapLoading } from '../../../../action/huntplanner-map-loader'
import { huntPlannerRightMenuBarClose } from '../../../../action/huntplanner-menu-bar'
import { countNonEmptyKeysExcluding } from '../../reusableComponents/commonFunctions/commonFunctions'
// import SelectedFilterOptions from '../moreFilterMenu/SelectedFilterOptions'
import RightMenuBar from '../rightMenuBar'
import { fetchPrivateLandGetFilterValues, fetchPrivateLandItems, privateLandPayloadAction } from '../../../../action/private-lands-action'

const TopMenuCoponent = (props) => {
  let [activeSelection, setActiveSelection] = useState('')
  let [loadSideMenuBar, setLoadSideMenuBar] = useState(false)// make it false after testing
  let [currentObj, setCurrentObj] = useState()
  let [apiActivityData, setApiActivityData] = useState([])
  let [selectedState, setSelectedState] = useState('')
  let [selectedActivity, setSelectedActivity] = useState('')
  let [landTrustItems, setlandTrustItems] = useState()
  let [loadSpinner, setLoadSpinner] = useState(true)

  useEffect(() => {
    fetchPrivateLandGetFilterValues()

    setSelectedState(props.selectedPrivateLandPayload.stateName)
    setSelectedActivity(props.selectedPrivateLandPayload.activity)

    handleFilter()

  }, [])

  let handleClick = (e) => {
    const name = e.target.name;
    if (activeSelection != name && name == 'state') {
      setActiveSelection(name)
      setApiActivityData([])
      setSelectedActivity('')
    } else if (activeSelection == name && name == 'state') {
      setActiveSelection('')
      setSelectedActivity('')
      // setSelectedState('')
    } else if (activeSelection == name && name == 'activity') {
      setActiveSelection('')
      setSelectedActivity('')
    } else if (name == 'activity') {
      setActiveSelection(name)
    }
  }

  let onSelectState = (value, nextSelection, object, activityObject) => {
    if (value == 'All') {
      setSelectedState("State (All)")
      setSelectedActivity('Activity (All)')
      setActiveSelection('')
      handleFilter('All', 'All')
    } else {
      setSelectedState(value)
      setApiActivityData(activityObject.returnActivitiesObject)
      setActiveSelection(nextSelection)
    }

  }

  let onSelectActivity = (value, nextSelection, object, huntTypesOptions) => {
    setSelectedActivity(value)
    setActiveSelection('')
    handleFilter(selectedState, value)
  }


  let handleFilter = (selectedState, value) => {
    setLoadSpinner(true)
    let payload = {
      stateName: selectedState == 'All' ? '' : selectedState ? selectedState : props.selectedPrivateLandPayload.stateName,
      activity: value == 'All' ? '' : value ? value : props.selectedPrivateLandPayload.activity ? props.selectedPrivateLandPayload.activity : '' // props.selectedPrivateLandPayload.selectedActivity ? props.selectedPrivateLandPayload.selectedActivity : selectedActivity  //pavan need to update when going staging
    }

    props.privateLandPayloadAction(payload)

    props.fetchPrivateLandItems(payload)
      .then((res) => {
        setLoadSpinner(false)
      })
      .catch((err) => setLoadSpinner(false))


  }

  let handleMoreFilters = () => {
    // setLoadFilterSideMenuBar(!loadFilterSideMenuBar)

    // if (loadFilterSideMenuBar) {
    //     props.expandMorefilterMenu(false)
    // } else {
    //     props.expandMorefilterMenu(true)
    // }
  }

  let handleClickXYZ = () => {
    // multiTileHuntLayersXYZ(props.huntplannerMapReference)
  }

  return (
    <>
      {/* Blurrrr */}
      <div className='hunt-planner-top-menu'
        style={{
          position: 'relative',
          // right: (props.landTrustMenuBar ? '14%' : '')//27%
          // right: (props.landTrustrRightToolbar ? '10%' : loadSideMenuBar ? '12%' : '')


          right: (props.landTrustMenuBar ? (props.lantTrustPrivateLandDetails || props.landTrustRightMenuBarObj.expanded) ? '23%' : '12%' : '')
          // landTrustMenuBar
        }}
      >
        <div className="button-container-style">
          <ReusableButton
            buttonName="state"
            className="lets-go-button-label"
            label={selectedState ? selectedState : "State (All)"}
            onClick={handleClick}
            disabled={props.lantTrustPrivateLandDetails}
            variant={(props.lantTrustPrivateLandDetails || props.landTrustRightMenuBarObj.expanded) ? "disable" : "primary"}
            size="small"
            buttonWidth="200px"
            buttonHeight="38px"
            buttonColor={activeSelection == 'state' ? "#589500" : ''}
            borderColor={activeSelection == 'state' ? '' : '#589500'}
          />
          {activeSelection == 'state' &&
            <div className="dropdown-wrapper">
              <DropDownMenu
                DropDownName={"state"}
                currentObj={currentObj}
                dropStateOptions={props.privateLandFilterValues}
                onSelect={onSelectState} nextSelection='activity' />
            </div>}
        </div>

        <div className="button-container-style">
          <ReusableButton
            buttonName='activity'
            className='lets-go-button-label'
            disabled={!selectedState || props.lantTrustPrivateLandDetails || selectedState == 'State (All)'}
            label={selectedActivity ? selectedActivity : 'Activity (All)'}
            onClick={handleClick}
            variant={(props.lantTrustPrivateLandDetails || props.landTrustRightMenuBarObj.expanded) ? "disable" : "primary"}
            size="small"
            buttonWidth='200px'
            buttonHeight="38px"
            buttonColor={activeSelection == 'activity' ? "#589500" : ''}
            borderColor={activeSelection == 'activity' ? '' : '#589500'}
          />
          {activeSelection == 'activity' && selectedState != 'All' &&
            <div className="dropdown-wrapper">
              <DropDownMenu DropDownName={"activity"}
                dropDownOptions={apiActivityData}
                onSelect={onSelectActivity}
              // nextSelection='huntTypes'
              />
            </div>
          }
        </div>

        {props.landTrustMenuBar ? <RightMenuBar landTrustItems={landTrustItems} spinner={loadSpinner}></RightMenuBar> : ''}

      </div >
    </>
  )
}

const mapStateToProps = state => ({
  huntplannerStatesData: state.huntplannerStatesData,
  auth: state.auth,
  huntplannerMapReference: typeof state.huntplannerMapReference === 'function' ? state.huntplannerMapReference() : null,
  huntPlannerSelectedOtions: state.huntPlannerSelectedOtions,
  huntplannerMorefiltersState: state.huntplannerMorefilters,
  huntplannerRightToolbarState: state.huntplannerRightToolbar,
  huntplannerActiveLayersDetails: state.huntplannerActiveLayersDetails,
  huntMapLoader: state.huntMapLoader,
  huntPlannerUnitRightMenuBar: state.huntPlannerUnitRightMenuBar,
  huntPlannerFilterOptionsState: state.huntPlannerFilterOptions,
  landTrustMenuBar: state.landTrustMenuBar,
  privateLandFilterValues: state.privateLandFilterValues,
  lantTrustPrivateLandDetails: state.lantTrustPrivateLandDetails,
  selectedPrivateLandPayload: state.selectedPrivateLandPayload,
  landTrustRightMenuBarObj: state.landTrustRightMenuBarObj

})

const mapDispatchToProps = dispatch => ({
  fetchHuntPlannerLayers: (cb) => dispatch(fetchHuntPlannerLayers(cb)),
  huntPlannerActiveOtions: (payload) => dispatch(huntPlannerActiveOtions(payload)),
  huntPlannerFilterOptions: (payload) => dispatch(huntPlannerFilterOptions(payload)),
  huntplannerMorefilters: (payload) => dispatch(huntplannerMorefilters(payload)),
  fetchGetFilterCount: (payload) => dispatch(fetchGetFilterCount(payload)),
  fetchGetStateGetExtent: (payload, state) => dispatch(fetchGetStateGetExtent(payload, state)),
  fetchGetFilterValues: (payload) => dispatch(fetchGetFilterValues(payload)),
  expandMorefilterMenu: (payload) => dispatch(expandMorefilterMenu(payload)),
  closeMorefilterMenu: () => dispatch(closeMorefilterMenu()),
  startMapLoading: () => dispatch(startMapLoading()),
  stopMapLoading: () => dispatch(stopMapLoading()),
  huntPlannerRightMenuBarClose: () => dispatch(huntPlannerRightMenuBarClose()),
  huntPlannerRightMenuBarexpand: (payload) => dispatch(huntPlannerRightMenuBarexpand(payload)),
  huntPlannerRightMenuBarHide: () => dispatch(huntPlannerRightMenuBarHide()),
  fetchPrivateLandGetFilterValues: () => dispatch(fetchPrivateLandGetFilterValues()),
  fetchPrivateLandItems: (payload) => dispatch(fetchPrivateLandItems(payload)),
  privateLandPayloadAction: (payload) => dispatch(privateLandPayloadAction(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(TopMenuCoponent)